import React from "react";
import { Outlet } from "react-router-dom";
import "./WebLayout.css";

const WebLayout = () => {
  return (
    <div className="WebLayout">
      <Outlet />
    </div>
  );
};

export default WebLayout;
